import React from "react";
import { Modal, ScrollView, StyleSheet, Text, View } from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import * as Colors from "../../../styles/colors";
import * as Fonts from "../../../styles/typography";
import ColorCircle from "./ColorCircle";
import { COLOR_VEHICLES } from "../../../services/Config";

export default function ColorPickerModal({
  modalVisible,
  setModalVisible,
  setColor,
}) {
  const onPressColorCircle = (colorName) => {
    setColor(colorName)
    setModalVisible(!modalVisible)
  }
  return (
    <Modal
      animationType="fade"
      transparent={true}
      style={{ backgroundColor: "#000" }}
      visible={modalVisible}
      onRequestClose={() => setModalVisible(!modalVisible)}
    >
      <View style={styles.centeredView}>
        <View style={styles.modalView}>
          <Icon
            name="close"
            size={32}
            onPress={() => {
              setModalVisible(!modalVisible);
            }}
            style={styles.closeButton}
          />
          <View style={styles.titleView}>
            <Text style={styles.titleText}>{"Selecione uma cor"}</Text>
          </View>
          <ScrollView contentContainerStyle={{
            alignItems: "center",
          }}
            style={{ width: "100%" }}>
            {
              COLOR_VEHICLES.map((color) => {
                return <ColorCircle
                  colorName={color.name}
                  colorFill={color.hex}
                  onPress={onPressColorCircle}
                  key={color.name} />
              })
            }
          </ScrollView>
        </View>
      </View>
    </Modal >
  );
}

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0,0,0,0.5)",
  },
  titleView: {
    marginBottom: 8,
    alignItems: "center",
  },
  titleText: {
    textAlign: "center",
    fontSize: Fonts.FONT_SIZE_20,
    fontWeight: "bold",
  },
  modalView: {
    margin: 20,
    backgroundColor: Colors.WHITE,
    borderRadius: 8,
    padding: 16,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    width: "70%"
  },
  closeButton: {
    marginLeft: "auto",
    color: Colors.GRAY_DARK,
  },
});
